import React from "react";
import Header from "./Header";

const UserProfile = () => {
  return (
    <div className="w-full h-auto flex flex-col items-center justify-center bg-primary">
      <Header />
      User Profile
    </div>
  );
};

export default UserProfile;
